import React from 'react';
import PropTypes from 'prop-types';
import { SkuButtonFlowListener, SkuDetailFlowButtons } from './SkuDetailFlowButtons';
import { SkuParamListener } from '../../domain/models/SkuDetail';
import { AnimationTypeValues, getAnimationClass } from '../../presentation/constants/AnimationType';
import { RequestParam } from '../../domain/models/RequestParam';

export const SkuSelectAmount = ({
    nameParam,
    amounts,
    buttonFlowListener,
    skuParamListener,
    animationType
}: any) => {

    return (
        <div className={getAnimationClass(animationType)}>
            <div className="d-flex flex-row flex-wrap align-items-center justify-content-center m-4" >
                {
                    amounts.map((a: number) => {
                        return <div className="amountbtn"
                            onClick={() => {
                                buttonFlowListener?.onContinuePressed(new RequestParam(nameParam, `${a}`,'Monto'));
                            }}
                        >${a}</div>
                    })
                }
            </div>
            <div className="mt-4">
            <SkuDetailFlowButtons listener={
                new SkuButtonFlowListener({
                    onBackPressed: buttonFlowListener?.onBackPressed,
                    onContinuePressed: undefined
                })
            } />
            </div>
        </div>
    )
}

SkuSelectAmount.propTypes = {
    nameParam: PropTypes.string.isRequired,
    amounts: PropTypes.arrayOf(PropTypes.number).isRequired,
    buttonFlowListener: PropTypes.instanceOf(SkuButtonFlowListener),
    skuParamListener: PropTypes.instanceOf(SkuParamListener),
    animationType: PropTypes.oneOf(AnimationTypeValues)
}
